import Component from '@glimmer/component';
import { tv } from 'tailwind-variants';
import { PhInfo, PhWarning, PhXCircle, PhCheckCircle } from 'ember-phosphor-icons';
import { eq } from '../utilities.ts';

const alertStyles = tv({
  slots: {
    base: 'flex items-start rounded-md p-4',
    iconContainer: 'flex flex-col justify-center flex-shrink mr-3',
  },
  variants: {
    intent: {
      default: {
        base: 'flex items-start rounded-md p-4 bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
        iconContainer: 'text-blue-500 dark:text-blue-400',
      },
      primary: {
        base: 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
        iconContainer: 'text-purple-500 dark:text-purple-400',
      },
      warning: {
        base: 'bg-yellow-50 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300',
        iconContainer: 'text-yellow-500 dark:text-yellow-400',
      },
      danger: {
        base: 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300',
        iconContainer: 'text-red-500 dark:text-red-400',
      },
      success: {
        base: 'bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300',
        iconContainer: 'text-green-500 dark:text-green-400',
      },
    },
  },
});

interface AlertSignature {
  Args: {
    intent?: 'warning' | 'danger' | 'success' | 'primary' | 'default';
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class Alert extends Component<AlertSignature> {
  slotClass = (slot: 'base' | 'iconContainer') => {
    return alertStyles({ intent: this.args.intent || 'default' })[slot]();
  };

  <template>
    <div class={{this.slotClass "base"}} ...attributes>
      <div class={{this.slotClass "iconContainer"}}>
        {{#if (eq @intent "warning")}}
          <PhWarning @size="24" />
        {{else if (eq @intent "danger")}}
          <PhXCircle @size="24" />
        {{else if (eq @intent "success")}}
          <PhCheckCircle @size="24" />
        {{else}}
          <PhInfo @size="24" />
        {{/if}}
      </div>
      <div>
        {{yield}}
      </div>
    </div>
  </template>
}
